import { Breadcrumb, DSIcon } from '../common/atoms';
import React, { Component } from 'react';
import { Drawer, Popover, Alert } from 'antd';
import Button from '../common/atoms/DSButton';
import { Link } from 'react-router-dom';
import EditorialHeader from '../tailwind/molecules/EditorialHeader';
import Card from '../tailwind/atoms/Card';
import axios from 'axios';
import { Calendar, FullCalendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import KnowMoreDrawer from './KnowMoreDrawer'
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';
import { SALES_ROLE } from '../../constants/overview';

class CalendarComp extends Component {
  constructor(props) {

    super(props);
    this.state = {
      events: [],
      overviewEventId: '0',
      showKnowMoreModal: false,
      visible: false,
      clicked: false,
      calendar_url: sessionStorage.getItem('calendar_url')
    };

  }

  componentDidMount() {
    let key = (!this.props.location.state || this.props.location.state.overviewEventId === null || this.props.location.state.overviewEventId === '') ? '0' : this.props.location.state.overviewEventId
    this.setState({ overviewEventId: key })
    this.fetchEvents()
  }

  handleVisibleChange = (visible) => {
    this.setState({
      clicked: visible
    });
  }

  updateEvents(e) {
    let that = this
    var calendarEl = document.getElementById('fullcalendar');
    var calendar = new Calendar(calendarEl, {
      plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      defaultDate: Date.now(),

      navLinks: true, // can click day/week names to navigate views
      editable: false,
      eventLimit: true, // allow "more" link when too many events
      events: e,
      eventClick: function (info) {
        { that.showEvent(info.event.id) };
      },
      eventTimeFormat: { // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit'
      }
    });


    calendar.render();
  }

  fetchEvents = () => {
    let that = this
    let url = window.API_URL + "corporate/events/all_events"
    window.axios.get(url)
      .then(function (response) {
        that.setState({ events: response.data.events }, that.updateEvents(response.data.events))
        if (that.state.overviewEventId != '0') { that.showEvent(that.state.overviewEventId) }
        that.props.location.state = ''
      })
      .catch(function (error) {
        console.log(error);
      })

  }

  updateEvent = () => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });
    var list = document.getElementById("fullcalendar");
    while (list.hasChildNodes()) {
      list.removeChild(list.firstChild)
    }
    this.fetchEvents()
  }

  showEvent = (id) => {
    this.setState({ visible: true, event_id: id, showKnowMoreModal: true })
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });
  }

  handleClose = (e) => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });

  }

  cancelModal(e) {
    this.setState({ showKnowMoreModal: false })
  }

  renderModal() {
    if (this.state.showKnowMoreModal) {
      return (<Drawer
        width={'30%'}
        visible={this.state.visible}
        onCancel={this.handleCancel}
        onClose={this.handleClose}
        footer={null}
      >
        <KnowMoreDrawer visible={this.state.showKnowMoreModal}
          eventId={this.state.event_id}
          postUpdate={this.updateEvent}
          closeModal={this.cancelModal.bind(this)} />
      </Drawer>
      )
    } else {
      return (<div />)
    }
  }

  viewAllEvents() {
    this.props.history.push('/events')
  }

  onChange(checked) {
    if (checked === true) {
      window.open('webcal://localhost:3000/v1/corporate/events/sync_calendar.ics')
    }
  }

  copyCalendarUrl() {
    let textarea = document.createElement('textarea');
    textarea.id = 't'
    textarea.style.height = 0
    document.body.appendChild(textarea)
    textarea.value = document.getElementById("copy_calendar_url").innerText
    let selector = document.querySelector('#t')
    selector.select()
    document.execCommand('copy')
    alert("Ekincare calendar URL copied")
    document.body.removeChild(textarea)
  }

  renderCreateEvent() {
    this.props.history.push('/wellness-calendar/create-event')
  }

  render() {
    const calendarUrl = this.state.calendar_url;
    const syncPopoverVisible = this.state.clicked && !(SALES_ROLE === 'sales');
    const popoverContent = (
      <div className="max-w-sm space-y-ds-3">
        <div id="copy_calendar_url" className="font-mono text-ts-sm break-all text-gray-700">
          {calendarUrl}
        </div>
        <div className="flex flex-wrap justify-end gap-x-ds-4 gap-y-ds-2">
          <a
            href={calendarUrl}
            className="text-ts-sm font-semibold text-blue-600 transition-colors hover:text-blue-700 focus:outline-none focus-visible:rounded-sm focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
          >
            Open Calendar
          </a>
          <button
            type="button"
            onClick={this.copyCalendarUrl}
            className="text-ts-sm font-semibold text-blue-600 transition-colors hover:text-blue-700 focus:outline-none focus-visible:rounded-sm focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
          >
            Copy
          </button>
        </div>
      </div>
    );
    return (
      <div className="pt-ds-5 wellness-calendar-page">
        <Breadcrumb list={[{ text:'Engagement', link:'/stepathon' }, { text:'Calendar', link:'#' }]} classes='mb-1' />
        <p className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-ds-4'>Calendar</p>
        <div className="mb-ds-6 space-y-ds-4">
          <div className="flex flex-col gap-ds-3">
            {syncPopoverVisible ? (
              <Alert
                message="We will try to open your default calendar when you click on 'Open Calendar' and will add these events. In case the default calendar doesn't open please use 'Copy' to copy the calendar URL, where you can sync these events to your calendar manually."
                type="info"
                banner
                className="rounded-ds-lg border border-blue-100 bg-blue-50/90 text-gray-800 [&_.ant-alert-message]:text-ts-sm"
              />
            ) : null}

            <div className="flex flex-col gap-ds-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
              <Popover
                content={popoverContent}
                title={<span className="text-ts-sm font-semibold text-gray-900">Calendar URL</span>}
                trigger="click"
                visible={syncPopoverVisible}
                onVisibleChange={this.handleVisibleChange}
                placement="bottomRight"
                overlayClassName="max-w-md"
              >
                <span className="inline-flex w-full sm:w-auto">
                  <Button type="default" disabled={SALES_ROLE === 'sales'} className="w-full sm:w-auto">
                    <DSIcon name="sync" className="mr-2 inline-block text-gray-600" size={16} />
                    Sync calendar
                  </Button>
                </span>
              </Popover>
              <Button type="default" className="w-full sm:w-auto">
                <Link className="block w-full text-center sm:inline" to="/wellness-calendar/events">
                  View events
                </Link>
              </Button>
              <Button
                type="primary"
                icon="plus"
                className="w-full sm:w-auto"
                onClick={this.renderCreateEvent.bind(this)}
              >
                Create event
              </Button>
            </div>
          </div>
        </div>

        <Card variant="default" padding="compact" className="min-h-[28rem] overflow-hidden">
          <div id="fullcalendar" className="fc-theme-standard min-h-[24rem] [&_.fc-toolbar]:flex-wrap [&_.fc-toolbar]:gap-y-2" />
        </Card>
        {this.renderModal()}
      </div>
    );
  }
}
export default CalendarComp;